import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useGetTeamsQuery } from "../../features/teams/teamsApi";
import AddTeamUserModal from "./AddTeamUserModal";
import SingleTeam from "./SingleTeam";

export default function TeamDetails() {
    const [openUserModal, setOpenUserModal] = useState(false);
    const [teamId, setTeamId] = useState(null);

    const controlUserModal = () => {
        setOpenUserModal((prevState) => !prevState);
    };

    const {data : teams, isLoading, isError, isSuccess } = useGetTeamsQuery();
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};

    let content = null;

    if(isLoading) {
        content = "Loading....";
    }

    else if(!isLoading && isError) {
        content = "Something went wrong";
    }

    else if(!isLoading && !isError && isSuccess && teams?.length > 0) {
        content = teams
                    ?.slice()
                    ?.filter(team => team.users.find(user => user?.id?.toString() === loggedInUser?.id?.toString()))
                    ?.sort((a, b) => b.timestamp - a.timestamp)
                    ?.map(team => <SingleTeam key = {team.id} team = {team} setTeamId = {setTeamId} control = {controlUserModal} />);
    }
    return (
        <div
        className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto"
    >
       {content}
       <AddTeamUserModal open={openUserModal} control = {controlUserModal} teamId = {teamId} />
    </div>
    )
}